import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_AdvisorConfiguration = {
    _v1: {
        getAdvisorConfiguration: { method: HttpMethod.GET, path: '/v1/get-advisor-configuration' },
    }
};
//# sourceMappingURL=api-def.js.map